import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export type NumpadValue = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 'clear' | '00';

interface NumpadButton {
  value: NumpadValue;
  action: (value: NumpadValue) => void;
  icon?: string;
}

@Component({
    selector: 'app-numpad',
    template: `
    <div class="d-flex align-items-center flex-column">
      <div class="d-flex flex-row" *ngFor="let row of buttons">
        <div class="d-flex align-items-center button-parent h-48px w-48px h-md-64px w-md-64px m-1 m-md-2"
             *ngFor="let button of row">
          <button *ngIf="button !== null"
                  type="button"
                  class="btn w-100 h-100 fw-bold"
                  [disabled]="disabled"
                  [class.btn-numpad-dark]="theme==='dark'"
                  [class.btn-numpad-light]="theme==='light'"
                  (click)="button.action(button.value)">
            <span *ngIf="!button.icon">{{button.value}}</span>
            <span *ngIf="button.icon" class="material-icons">{{button.icon}}</span>
          </button>
        </div>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }
  `],
    standalone: false
})
export class NumpadComponent implements OnChanges, OnInit {
  @Input() showDecimalZeroes = false;
  @Input() disabled = false;
  @Input() theme: 'dark' | 'light' = 'light';
  @Output() buttonPress = new EventEmitter<NumpadValue>();

  buttons: (NumpadButton | null)[][] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showDecimalZeroes) {
      this.initLayout();
    }
  }

  ngOnInit() {
    this.initLayout();
  }

  private initLayout() {
    this.buttons = [
      [
        { value: 1, action: (value) => this.buttonPress.emit(value) },
        { value: 2, action: (value) => this.buttonPress.emit(value) },
        { value: 3, action: (value) => this.buttonPress.emit(value) },
      ],
      [
        { value: 4, action: (value) => this.buttonPress.emit(value) },
        { value: 5, action: (value) => this.buttonPress.emit(value) },
        { value: 6, action: (value) => this.buttonPress.emit(value) },
      ],
      [
        { value: 7, action: (value) => this.buttonPress.emit(value) },
        { value: 8, action: (value) => this.buttonPress.emit(value) },
        { value: 9, action: (value) => this.buttonPress.emit(value) },
      ],
      [
        (this.showDecimalZeroes ? { value: '00', action: (value) => this.buttonPress.emit(value) } : null),
        { value: 0, action: (value) => this.buttonPress.emit(value) },
        { value: 'clear', action: (value) => this.buttonPress.emit(value), icon: 'close' },
      ]
    ];
  }
}
